import {ApplicationConfig, ErrorHandler, importProvidersFrom, Injectable, provideAppInitializer} from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { configFactory } from './shared/utils';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app-routes';
import {
  AddTranslationDialogState,
  ApplicationSelectorState,
  AppLoadingState,
  ConfigState,
  InitialDataState,
  MenuState,
  SelectedTableFiltersState,
  SnackbarActionHandler,
  TableFilterState,
  TranslationEditorState,
  TranslationTableState,
  UserState,
} from './core/state';
import { authInterceptorFn, ConfigService, GlobalErrorHandlerService, IconService } from './core/service';
import { MATERIAL_PROVIDERS } from './config';
import { HandlerModule } from './core/action-handler.module';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateLoader,
  TranslateModule
} from "@ngx-translate/core";
import {Observable, of} from "rxjs";

const states = [
  AddTranslationDialogState,
  AppLoadingState,
  ApplicationSelectorState,
  ConfigState,
  InitialDataState,
  MenuState,
  SelectedTableFiltersState,
  TableFilterState,
  TranslationEditorState,
  TranslationTableState,
  UserState,
];

@Injectable()
export class TranslationLoader implements TranslateLoader {
  constructor() {}

  getTranslation = (lang: string): Observable<any> =>{
    return of({"form.error.required": "required", "login.username": "username", "login.password": "password", "login.logIn": "log in", "login.forgotPassword": "do NOT click"})
  }

}

@Injectable({ providedIn: 'root' })
export class MissingTranslationService implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): void {
    console.log(`Missing translation: ${params.key}`);
  }
}

const handlers = [SnackbarActionHandler];

export const appConfig: () => ApplicationConfig = () => ({
  providers: [
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptorFn])),
    provideRouter(routes, withComponentInputBinding()),
    ...MATERIAL_PROVIDERS,
    importProvidersFrom(
      HandlerModule.forRoot(handlers),
      NgxsModule.forRoot(states),
      NgxsStoragePluginModule.forRoot({
        keys: [ApplicationSelectorState, AddTranslationDialogState, SelectedTableFiltersState, TranslationEditorState],
      }),
      NgxsFormPluginModule.forRoot(),
      NgxsReduxDevtoolsPluginModule.forRoot(),
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useClass: TranslationLoader,
          deps: [],
        },
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useClass: MissingTranslationService,
        },
      })
    ),
    IconService,
    ConfigService,
    provideAppInitializer(configFactory()),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
  ],
});
